module.exports = __webpack_public_path__ + "5acbc774922a03670aaf8b7aab7eb018.svg";